import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReviewHistoryResponse } from './get-review-history-response';
import { getReviewHistoryResponseSchema } from './get-review-history-response';

export interface IGetReviewHistoryRequest {
  cursor?: string;
}

export async function getReviewHistoryApi(
  params?: IGetReviewHistoryRequest,
): Promise<IValidatedResponse<IGetReviewHistoryResponse>> {
  return getRequest<IGetReviewHistoryResponse>({
    path: '/progress/reviews',
    schema: getReviewHistoryResponseSchema,
    options: {
      params: params?.cursor ? { cursor: params.cursor } : undefined,
    },
  });
}
